export const voucherTemplate_partnerInfo = 'MarketingPartnerInfo'
export const voucherTemplate_param_key = 'voucherTemplate_marketing_param_key'
export const localCache_prefix = 'voucherTemplate_marketing'
export const partnerVoucherTemplateNames = [voucherTemplate_partnerInfo]
